import React from "react"; 
import { BsTwitter } from "react-icons/bs";
import { SiLinkedin } from "react-icons/si";
import { BsYoutube } from "react-icons/bs";
import { FaFacebookF } from "react-icons/fa";

const Footer = () => {
  return (
    <div className="footer-wrapper">
      <div className="footer-section-one">
        <div className="footer-logo-container">
          Monmarche
        </div>
        <div className="footer-icons">
          <BsTwitter />
          <SiLinkedin />
          <BsYoutube />
          <FaFacebookF />
        </div>
      </div>
      <div className="footer-section-two">
        <div className="footer-section-columns">
          <span>Qualité</span>
          <span>Aide</span>
          <span>Partage</span>
          <span>Carrieres</span>
          <span>Temoignages</span> 
        </div>
        <div className="footer-section-columns">
          <span>+224 612 12 12 29</span>
          <span>monmarchegn@gmail.com</span> 
        </div>
        <div className="footer-section-columns">
          <span><a href="/policy">Termes & Conditions</a></span>
          <span><a href="/policy">Politique de Confidentialité</a></span>
        </div>
      </div>
    </div>
  );
};

export default Footer;
